import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../client';
import {
  nudgeRecordingContract,
  type NudgeRecordingRequest,
  type NudgeRecordingResponse
} from '@bliks-io/contracts';

export function useNudge() {
  return useMutation({
    mutationFn: async (data: NudgeRecordingRequest): Promise<NudgeRecordingResponse> => {
      const { data: response } = await apiClient.post<NudgeRecordingResponse>(
        nudgeRecordingContract.path,
        data,
        // The dialog maps the 403 itself (e.g. target not active) — the
        // global "insufficient permissions" toast would mislabel it.
        { suppressForbiddenToast: true }
      );
      return response;
    }
  });
}
